export default {
  namespaced: true,
  state: () => ({
    favorite: null,
    continents: null,
  }),
  getters: {
    favorites: (state) => state.favorite || [],
    continents: (state) => state.continents || [],
  },
  actions: {
    async getCities({ commit }) {
      try {
        const { data } = await this.$http.get('/platform/v1/cities')
        await commit('setCities', data)
      } catch (err) {
        console.log(err)
      }
    },
  },
  mutations: {
    setCities(state, item) {
      state.favorite = item.favorite
      state.continents = item.continents
    },
  },
}
